import bannerImage from '../assets/heroBanner.svg';

function Banner() {
 return (
  <img className='fillWidth' src={bannerImage}></img>
 );
}

export default Banner;
